export const WartebereichUmgehenErlaubnisse = ["ORGANISATOR", "ORGANISATION", "ORGANISATIONUNDVERBUENDETE", "JEDER"] as const;

type WartebereichUmgehenErlaubnis = typeof WartebereichUmgehenErlaubnisse[number];

export default WartebereichUmgehenErlaubnis;
